import { useMemo } from "react";
import { nanoid } from "nanoid";
function useId(prefix) {
  return useMemo(() => prefix + "-" + nanoid(), [prefix]);
}
export {
  useId
};
//# sourceMappingURL=useId.js.map
